import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { NOTES_TEMPLATE_CONTROLLER } from "api/Service";

export const useNoteTemplatesAll = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["noteTemplatesAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${NOTES_TEMPLATE_CONTROLLER}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
